import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select, DatePicker, Switch, InputNumber, Row, Col } from 'antd';
import { IResourceComponentsProps } from '@refinedev/core';
import dayjs from 'dayjs';
import { ConfigVersionSelect } from '@/components/ConfigVersionSelect';

export const OfferCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm();

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Config Version"
          name="configVersionId"
          extra="Leave empty to apply to every build. Pick a config version to limit this to the app versions mapped to it."
        >
          <ConfigVersionSelect style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Type"
          name="type"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            options={[
              { label: 'Standard', value: 'standard' },
              { label: 'Special', value: 'special' },
              { label: 'Limited Time', value: 'limited_time' },
            ]}
          />
        </Form.Item>
        <Form.Item label="Platform" name="platform" initialValue="all">
          <Select
            options={[
              { label: 'All', value: 'all' },
              { label: 'Android', value: 'android' },
              { label: 'iOS', value: 'ios' },
            ]}
          />
        </Form.Item>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true }]}
              getValueProps={(value) => ({ value: value ? dayjs(value) : '' })}
            >
              <DatePicker showTime style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="End Date"
              name="endDate"
              rules={[{ required: true }]}
              getValueProps={(value) => ({ value: value ? dayjs(value) : '' })}
            >
              <DatePicker showTime style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={12} sm={8}>
            <Form.Item label="Priority" name="priority" initialValue={0}>
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={12} sm={8}>
            <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
